var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:_vm.classes,style:(("--p-height: " + _vm.height + "px")),attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"secondary","width":2,"size":210}},[_c('img',{attrs:{"src":require("../../../static/Icononaranjo.png"),"alt":"logo","width":"auto","height":"100px"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30ed24b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Loader.vue
// module id = RS0Z
// module chunks = 38